import { IUser, useMainStore } from "."
import { Role } from "../../libs/interfaces/layouts"

export const isRole = (role: Role[] | Role): boolean => {
    const user = useMainStore.getState().user
    return Array.isArray(role)
        ?
        !!user.roles?.filter((r: Role) => role.filter((rr: Role) => rr === r).length > 0).length
        :
        !!user.roles?.filter((r: Role) => r === role).length 
}
export const isUserRole = (role: Role[] | Role, user: IUser) => { 
    if(Array.isArray(role))
    {
        return user.roles?.filter((r: Role) => role.filter((rr: Role) => rr === r).length > 0).length > 0
    }
    else
    {
        return user.roles?.filter((r: Role) => r === role).length > 0
    }
}

export const isUser = () => {
    const user = useMainStore.getState().user
    return !!user?.id
}

export const useUser = ():IUser => {
    const user = useMainStore.getState().user
    const anonymUser = useMainStore.getState().getAnonymUser() 
    return user?.id ? user : anonymUser
}

export function isAnonym() : boolean {
    const user = useMainStore.getState().user
    return !user.id
}